import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import http from './api/config'
Vue.use(ElementUI);

import './assets/style/index.less'
import './assets/style/iconfont/iconfont.css'

Vue.config.productionTip = false
Vue.prototype.$http = http

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
